import { render, staticRenderFns } from "./InBed.vue?vue&type=template&id=3640ed50&scoped=true"
import script from "./InBed.vue?vue&type=script&lang=js"
export * from "./InBed.vue?vue&type=script&lang=js"
import style0 from "./InBed.vue?vue&type=style&index=0&id=3640ed50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640ed50",
  null
  
)

export default component.exports